(function(){
	"use strict";

	angular
		.module('pwc.controllers')
		.controller('PurchaseOnOrderReportController', PurchaseOnOrderReportController);

	PurchaseOnOrderReportController.$inject = ['$window', 'WineRepository', '$log', 'lodash', '$state', '$timeout', '$location', '$anchorScroll'];

	function PurchaseOnOrderReportController($window, WineRepository, $log, lodash, $state, $timeout, $location, $anchorScroll){

		/* jshint validthis: true */
		var self = this;

		self.winePurchasesGrouped = {};

		self.printSettings = {
			"fontSize": 12,
			"style": "custom"
		};

		self.report = {
			loading: true,
			groups: [],
			totals: {}
		};

		self.currentDate = $window.moment().format('MM/DD/YYYY');

		self.currentYear = $window.moment().format('YYYY');

		self.title = $state.current.data.title;

		self.jumpTo = jumpTo;

		self.print = print;

		self.updateView = updateView;

		self.initialize = initialize;

		/** initialize */
		initialize();

		/** begin methods */

		function initialize() {

			_resetReport();

			WineRepository.all().then(function(wineEntities){

				if (wineEntities.length > 0){

					self.report.tableHeaders = [
						'Wine',
						'Size',
						'Bottles In Cellar',
						'Bottles On Order',
						'Purchased / Due',
						'Cost per bottle'
					];

					lodash.forEach(wineEntities, function(wine) {
						// @todo wine.cellar.ordered doesn't seem to be accurate, always false.
						var isOnOrder = (wine.getOnOrderQty() > 0);

						if (wine.hasHistory() && isOnOrder) {
							var purchases = wine.getPurchasesOnOrder();

							if (purchases.length > 0) {
								_.forEach(purchases, function(purchase) {
									var source = lodash.isNotEmptyOrNull(purchase.source) ? purchase.source : 'Source not set';

									if (! lodash.isArray(self.winePurchasesGrouped[source])) {
										self.winePurchasesGrouped[source] = [];
									}
									self.winePurchasesGrouped[source].push({
										qty: purchase.qty,
										price: purchase.price,
										due: purchase.due,
										wine: wine
									});
								});
							}
						}
					});

					_updateReport();

					return true;
				}

				return false;

			}).catch(function(err){
				$log.debug('Error getting wines', err);
			});
		}

		function _updateReport() {
			var keyName = 'Source';
			var keyNamePlural = keyName + 's';

			// initialize totals
			var grandTotals = {
				bottlesOnOrder: 0,
				value: 0,
				groupCount: Object.keys(self.winePurchasesGrouped).length,
			};

			// @todo convert to an array so we can ensure order
			lodash.forEach(self.winePurchasesGrouped, function(purchases, source) {
				var groupTotals = {
					bottlesOnOrder: 0,
					value: 0
				};

				// total value for grouping
				groupTotals.value = lodash.sum(purchases, function(purchase) {
					return purchase.qty * purchase.price;
				});

				// update grand total value
				grandTotals.value += groupTotals.value;

				var formattedWines = [];

				lodash.forEach(purchases, function(purchase) {
					var varietal = (purchase.wine.varietal && purchase.wine.varietal.name) ? purchase.wine.varietal.name + ' ' : '';
					var category = (purchase.wine.category && purchase.wine.category.name) ? purchase.wine.category.name : '';
					var type = varietal + category;

					groupTotals.bottlesOnOrder += purchase.qty;
					
					var purchaseDate = lodash.isNotEmptyOrNull(purchase.date) ? $window.moment(purchase.date).format('ll') : '-';
					var dueDate = lodash.isNotEmptyOrNull(purchase.due) ? $window.moment(purchase.due).format('ll') : '-';

					// data we want to display on a single wine
					formattedWines.push({
						name: purchase.wine.getFullName(),
						appelation: purchase.wine.getFullAppellation(),
						type: type,
						size: purchase.wine.bottleSize.name,
						qtyRemaining: purchase.wine.cellar.qty,
						qtyOnOrder: purchase.qty, // the current purchase
						date: purchaseDate + ' / ' + dueDate,
						cost: $window.numeral(purchase.price).format('$0,0[.]00')
					});
				});

				grandTotals.bottlesOnOrder += groupTotals.bottlesOnOrder;

				self.report.groups.push({
					groupName: source,
					bottles: groupTotals.bottlesOnOrder,
					value: $window.numeral(groupTotals.value).format('$0,0[.]00'),
					wines: formattedWines
				});

			});

			// @todo sort self.report.groups by .groupName
			self.report.totals = [
				// 'GroupName / Wine',
				'Total ' + keyNamePlural + ': ' + grandTotals.groupCount,
				// 'Size',
				null,
				// 'Bottles in cellar',
				null,
				// 'Bottles on order',
				'Total Bottles On Order: ' + grandTotals.bottlesOnOrder,
				// Due Date
				null,
				// 'Value',
				$window.numeral(grandTotals.value).format('$0,0[.]00'),
			];

			// hide loading
			self.report.loading = false;
		}

		function updateView() {
			// remove existing groupings
			self.report.groups = [];

			// show loading
			self.report.loading = true;

			// let dom update to show loading
			$timeout(function(){
				// update
				_updateReport();
			});
		}

		function _resetReport() {
			// remove existing groupings
			self.report.groups = [];
			self.winePurchasesGrouped = {};

			// show loading
			self.report.loading = true;

			// reset totals
		}

		function jumpTo(id) {
			$location.hash('item-' + id);
			$anchorScroll();
		}

		function print(){
			return $window.print();
		}
	}

})();
